
import { mapGetters } from "vuex";
// import * as types from "../vuex/types";
// import api from "../vuex/api/index";

import Hero from "../components/Hero.vue";

export default {
  components: {
    Hero,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {
  },
  head() {
    return {
      title: 'Equipment Financing - Equipment Loans | American Credit',
      meta : [
        {
          hid: 'description',
          name: 'description',
          content: 'Equipment Loans & Equipment Financing for businesses. Up to $5 Million. American Credit provides funds in as little as 3-4 Business Days. Apply Now!'
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'equipment financing, equipment loans, equipment-based loans, commercial equipment financing, business equipment loans, construction equipment loans, American Credit'
        }
      ]
    }
  }
};
